var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "v-container",
    { attrs: { "pa-0": "" } },
    [
      _c(
        "v-layout",
        [
          _c(
            "v-flex",
            { attrs: { xs6: "", "pr-1": "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Name", rules: _vm.nameRule },
                model: {
                  value: _vm.Name,
                  callback: function ($$v) {
                    _vm.Name = $$v
                  },
                  expression: "Name",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-layout",
        [
          _c(
            "v-flex",
            { attrs: { xs6: "", "pr-3": "" } },
            [
              _c("v-text-field", {
                attrs: {
                  label: "Back tracking (Minutes)",
                  rules: _vm.numRuleNoZero,
                },
                scopedSlots: _vm._u([
                  {
                    key: "append",
                    fn: function () {
                      return [
                        _c(
                          "v-tooltip",
                          {
                            attrs: { bottom: "" },
                            scopedSlots: _vm._u([
                              {
                                key: "activator",
                                fn: function ({ on }) {
                                  return [
                                    _c("v-icon", _vm._g({}, on), [
                                      _vm._v("info_outline"),
                                    ]),
                                  ]
                                },
                              },
                            ]),
                          },
                          [
                            _vm._v(
                              "\n            Backtracking time refers the amount of time from the present the importer should look back when querying data."
                            ),
                            _c("br"),
                            _vm._v(
                              "\n            For example, a backtracking time of 120 would cause the importer to query data from 2hrs ago to the present.\n          "
                            ),
                          ]
                        ),
                      ]
                    },
                    proxy: true,
                  },
                ]),
                model: {
                  value: _vm.ExecuteInterval,
                  callback: function ($$v) {
                    _vm.ExecuteInterval = $$v
                  },
                  expression: "ExecuteInterval",
                },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "v-flex",
            { attrs: { xs6: "", "pl-3": "" } },
            [
              _c("v-text-field", {
                attrs: { label: "Type", disabled: "", rules: _vm.nullRule },
                model: {
                  value: _vm.ImporterType,
                  callback: function ($$v) {
                    _vm.ImporterType = $$v
                  },
                  expression: "ImporterType",
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c("v-text-field", {
        attrs: { label: "Description" },
        model: {
          value: _vm.Description,
          callback: function ($$v) {
            _vm.Description = $$v
          },
          expression: "Description",
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }